const CallAttemptsQuery = {
  title: 'Call Stats Summary Attempts By App Domain',
  query: {
    index: 'platform-callstats-*',
    body: {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: 'reporttype.keyword: callstats  AND tabletype.keyword: successTable AND app_domain.keyword: (###AppDomainPlaceholder###)',
              },
            },
            {
              range: {
                utc_date: {
                  gte: 'now-7d',
                  lte: 'now',
                },
              },
            },
          ],
        },
      },
      aggs: {
        ByDomain: {
          terms: {
            field: 'app_domain.keyword',
            size: 10,
          },
          aggs: {
            CallSummary: {
              date_histogram: {
                field: 'utc_date',
                interval: 'day',
                time_zone: 'America/New_York',
              },
              aggs: {
                SumCallAttempts: {
                  sum: {
                    field: 'call_attempts',
                  },
                },
              },
            },
          },
        },
      },
      size: 0,
    },
  },
};


const OutboundCallQuery = {
  title: 'Call Stats Outbound By App Domain',
  query: {
    index: 'platform-callstats-*',
    body: {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: 'reporttype.keyword: callstats AND calltype.keyword: outbound AND tabletype.keyword: successTable AND app_domain.keyword: (###AppDomainPlaceholder###)',
              },
            },
            {
              range: {
                utc_date: {
                  gte: 'now-7d',
                  lte: 'now',
                },
              },
            },
          ],
        },
      },
      aggs: {
        ByDomain: {
          terms: {
            field: 'app_domain.keyword',
            size: 10,
          },
          aggs: {
            CallSummary: {
              date_histogram: {
                field: 'utc_date',
                interval: 'day',
                time_zone: 'America/New_York',
              },
              aggs: {
                SumCallAttempts: {
                  sum: {
                    field: 'call_attempts',
                  },
                },
                SumUnAnsCalls: {
                  sum: {
                    field: 'unanswered_calls',
                  },
                },
                SumCallsAnsAudio: {
                  sum: {
                    field: 'answered_calls_with_audio',
                  },
                },
                SumCallsAnsNoStats: {
                  sum: {
                    field: 'answered_calls_without_stats',
                  },
                },
                SumCallsAnsNoAudio: {
                  sum: {
                    field: 'answered_calls_without_audio',
                  },
                },
                SumCallsFailed: {
                  sum: {
                    field: 'signalling_failed_calls',
                  },
                },
                SumCallErrors: {
                  sum: {
                    field: 'signalling_error_calls',
                  },
                },
                SumCallsInternational: {
                  sum: {
                    field: 'international_calls',
                  },
                },
                SumCallsBlocked: {
                  sum: {
                    field: 'blocked_calls',
                  },
                },
              },
            },
          },
        },
      },
      size: 0,
    },
  },
};

const InboundCallQuery = {
  title: 'Call Stats Inbound By App Domain',
  query: {
    index: 'platform-callstats-*',
    body: {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: 'reporttype.keyword: callstats AND calltype.keyword: inbound AND tabletype.keyword: successTable AND app_domain.keyword: (###AppDomainPlaceholder###)',
              },
            },
            {
              range: {
                utc_date: {
                  gte: 'now-7d',
                  lte: 'now',
                },
              },
            },
          ],
        },
      },
      aggs: {
        ByDomain: {
          terms: {
            field: 'app_domain.keyword',
            size: 10,
          },
          aggs: {
            CallSummary: {
              date_histogram: {
                field: 'utc_date',
                interval: 'day',
                time_zone: 'America/New_York',
              },
              aggs: {
                SumCallAttempts: {
                  sum: {
                    field: 'call_attempts',
                  },
                },
                SumUnAnsCalls: {
                  sum: {
                    field: 'unanswered_calls',
                  },
                },
                SumCallsAnsAudio: {
                  sum: {
                    field: 'answered_calls_with_audio',
                  },
                },
                SumCallsAnsNoStats: {
                  sum: {
                    field: 'answered_calls_without_stats',
                  },
                },
                SumCallsAnsNoAudio: {
                  sum: {
                    field: 'answered_calls_without_audio',
                  },
                },
                SumCallsFailed: {
                  sum: {
                    field: 'signalling_failed_calls',
                  },
                },
                SumCallErrors: {
                  sum: {
                    field: 'signalling_error_calls',
                  },
                },
              },
            },
          },
        },
      },
      size: 0,
    },
  },
};

const OnNetCallQuery = {
  title: 'Call Stats OnNet By App Domain',
  query: {
    index: 'platform-callstats-*',
    body: {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: 'reporttype.keyword: callstats AND calltype.keyword: onNet AND tabletype.keyword: successTable AND app_domain.keyword: (###AppDomainPlaceholder###)',
              },
            },
            {
              range: {
                utc_date: {
                  gte: 'now-7d',
                  lte: 'now',
                },
              },
            },
          ],
        },
      },
      aggs: {
        ByDomain: {
          terms: {
            field: 'app_domain.keyword',
            size: 10,
          },
          aggs: {
            CallSummary: {
              date_histogram: {
                field: 'utc_date',
                interval: 'day',
                time_zone: 'America/New_York',
              },
              aggs: {
                SumCallAttempts: {
                  sum: {
                    field: 'call_attempts',
                  },
                },
                SumUnAnsCalls: {
                  sum: {
                    field: 'unanswered_calls',
                  },
                },
                SumCallsAnsAudio: {
                  sum: {
                    field: 'answered_calls_with_audio',
                  },
                },
                SumCallsAnsNoStats: {
                  sum: {
                    field: 'answered_calls_without_stats',
                  },
                },
                SumCallsAnsNoAudio: {
                  sum: {
                    field: 'answered_calls_without_audio',
                  },
                },
                SumCallsFailed: {
                  sum: {
                    field: 'signalling_failed_calls',
                  },
                },
                SumCallErrors: {
                  sum: {
                    field: 'signalling_error_calls',
                  },
                },
              },
            },
          },
        },
      },
      size: 0,
    },
  },
};

const HighRiskQuery = {
  title: 'Call Stats High Risk By App Domain',
  query: {
    index: 'platform-summary-*',
    body: {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: 'eventType.keyword: sipProxyForbiddenHighRiskCall AND NOT value: 0 AND feature.keyword: (###AppDomainPlaceholder###)',
              },
            },
            {
              range: {
                '@timestamp': {
                  gte: 'now-7d',
                  lte: 'now',
                },
              },
            },
          ],
        },
      },
      aggs: {
        ByDomain: {
          terms: {
            field: 'feature.keyword',
            size: 10,
          },
          aggs: {
            CallSummary: {
              date_histogram: {
                field: '@timestamp',
                interval: 'day',
                time_zone: 'America/New_York',
              },
              aggs: {
                SumHighRiskCounts: {
                  sum: {
                    field: 'value',
                  },
                },
              },
            },
          },
        },
      },
      size: 0,
    },
  },
};

export default {
  CallAttemptsQuery, OutboundCallQuery, InboundCallQuery, OnNetCallQuery, HighRiskQuery,
};
